"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cloud = void 0;
var table_1 = require("./table");
var Cloud = /** @class */ (function () {
    function Cloud(config, reqInstance) {
        this.config = config;
        this.instance = reqInstance;
    }
    /**
     * @param tableName - 表名称
     */
    Cloud.prototype.table = function (tableName) {
        return new table_1.TableReference(tableName, this.config, this.instance);
    };
    return Cloud;
}());
exports.Cloud = Cloud;
